// Pipeline stages, spec 3.6. Seeded into pipeline_stages; the table is the source of truth at runtime.

export interface PipelineStage {
  id: string;
  label: string;
  sort: number;
  closed: boolean;
}

export const DEFAULT_STAGES: readonly PipelineStage[] = [
  { id: "klaerung", label: "Klärung", sort: 10, closed: false },
  { id: "ange_bot", label: "Ange.Bot", sort: 20, closed: false },
  { id: "angebot", label: "Angebot", sort: 30, closed: false },
  { id: "gewonnen", label: "Gewonnen", sort: 60, closed: true },
  { id: "verloren", label: "Verloren", sort: 70, closed: true },
  { id: "pausiert", label: "Pausiert", sort: 80, closed: true },
];

/** The stage in which a deal carries an offer stage (spec 3.6). */
export const OFFER_PHASE = "angebot";

/** Offer stage within the phase "Angebot": optional steps are states, not phases (a trial batch is not always made). */
export const OFFER_STAGES = ["indikativ", "probebatch", "final"] as const;
export type OfferStage = (typeof OFFER_STAGES)[number];

/** Suggested reasons for "Verloren"; the field also takes free text (e.g. HubSpot's reason). */
export const LOST_REASONS = ["Kunde hat abgesagt", "Abgelehnt durch Valphira"] as const;
